import React, {CSSProperties} from "react";

interface DefaultActivityImageProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}

const DefaultActivityImage: React.FC<DefaultActivityImageProps> = (props: DefaultActivityImageProps) => {
    const {color} = props;
    return (
        <div style={props?.style}>
            <svg viewBox="0 0 1000 1000" width={props.svgWidth || "32"} height={props.svgHeight || "32"}
                 className="images-icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px">
                <g>
                    <path fill={color ? color: '#ffffff'} d="M702.2,120l-32.9,57l114,65.8l32.9-57c9.1-15.8,3.7-35.9-12.1-45l-57-32.9C731.5,98.8,711.3,104.2,702.2,120
				z"/>
                    <path fill={color ? color: '#ffffff'} d="M500,158.2c20.8,0,41.2,2,61.3,4.9v-53.3l42.1-0.3V40.6c0-16.9-13.7-30.6-30.6-30.6H427.6
				C410.7,10,397,23.7,397,40.6v68.9l41.8,0.3v53.3C458.8,160.3,479.2,158.2,500,158.2z"/>
                    <path fill={color ? color: '#ffffff'} d="M500,193.8c-219.9,0-398.1,178.2-398.1,398.1C101.9,811.8,280.1,990,500,990s398.1-178.2,398.1-398.1
				S719.9,193.8,500,193.8z M686,779L454,618.4V391.7h67v191.7L724.2,724L686,779z"/>
                </g>
            </svg>
        </div>
    );
};

export default DefaultActivityImage;
